import {
	Component
} from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../animations/page-transitions';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import {
	CreateFastlaneWidgetComponent
} from '../../../fastlane/components/dashbord/copo-create-fastlane-widget.component';
import { CreateOrderWidgetComponent } from '../../../eorder/components/dashboard/create-order-widget.component';
import { CheckOfferWidgetComponent } from '../../../need4steel/components/dashbord/check-offer-widget.component';
import { OfferRequestWidgetComponent } from '../../../offer/components/dashboard/offer-request-widget.component';
import { BackButtonComponent } from '../back-button/back-button.component';
import { EFeasibilityWidgetComponent } from '../../../efeasibility/components/dashboard/efeasibility-widget.component';

@Component({
	selector: 'copo-sales-services-menu',
	templateUrl: './sales-services-menu.component.html',
	animations: pageTransitions,
	imports: [
		BackButtonComponent,
		TranslateModule,
		NgIf,
		OfferRequestWidgetComponent,
		CheckOfferWidgetComponent,
		CreateOrderWidgetComponent,
		CreateFastlaneWidgetComponent,
		EFeasibilityWidgetComponent
	]
})

export class SalesServicesMenuComponent {
	user: User;
	constructor(
		private readonly userService: UserService,
	) {
		this.user = this.userService.user;
	}
}
